import { ReactNode, useEffect, useRef, useState } from 'react';
import { ContactUsSection, CtaCard, Navbar, IndustryGrid, IndustryHero, Footer, LanguageToggle, Cta, Button, ImageCarousel } from '../../components';
import { useMotionValue, useScroll } from 'framer-motion';
import { INDUSTRIES, IndustriesType, PARTNERS } from '@/resources/constants';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { motion } from 'framer-motion'
import { FADE_BOTTOM } from '@/animations';
import Image from 'next/image';
import Balancer from 'react-wrap-balancer';
import { GridCard } from '@/components/GridCard';
const cameraIcon = "/icons/home/camera.svg"
const inventoryIcon = "/icons/home/inventory.svg"
const notificationIcon = "/icons/home/notification.svg"
const analyticsIcon = "/icons/home/analytics.svg"
const secureIcon = "/icons/home/secure.svg"
const retailImage = "/images/menu/retail.png"

const CARDS = [
  {
    title: "Theft & Loss Prevention",
    description: "Detect suspicious activity, prevent shoplifting, and reduce shrinkage with our security monitoring system. Real-time alerts enable staff to respond proactively, minimizing losses and enhancing store security.",
    icon: secureIcon,
  },
  {
    title: "Customer Behavior Analytics",
    description: "Understand customer movement, dwell time, and engagement patterns to optimize store layouts and marketing strategies.",
    icon: analyticsIcon,
  },
  {
    title: "Inventory & Shelf Management",
    description: "Ensure shelves stay stocked and products are properly displayed with AI-powered inventory tracking. Detect out-of-stock items, optimize restocking to maximize sales opportunities.",
    icon: inventoryIcon,
  },

]


export async function getStaticProps({ params, locale }: any) {
  const industry = INDUSTRIES.find(item => item.id === "retail");
  return {
    props: {
      industry,
      ...(await serverSideTranslations(locale, [
        'common',
      ])),
    },
  }
}

// export async function getStaticPaths() {
//   const paths = INDUSTRIES.map((industry) => ({
//     params: { industryId: industry.id.toString() },
//   }));

//   return { paths, fallback: true };
// }

export default function Retail({ industry }: { industry: IndustriesType }) {
  const [navbarTransparent, setNavbarTransparent] = useState(true)
  const { scrollYProgress, scrollY } = useScroll()
  const { t } = useTranslation();
  const router = useRouter();
  const { asPath: pathname } = router;

  // create a doubled list of items for mirroring effect
  const allPartners = [...PARTNERS, ...PARTNERS];

  const itemWidth = 140;
  // const visibleItemsCount = Math.floor(window.innerWidth / itemWidth);
  const totalItemsCount = PARTNERS.length * 2;  // doubled for mirroring


  const speed = 1;
  const carouselRef = useRef(null);
  const x = useMotionValue(0);

  // Create an effect to update the x position
  useEffect(() => {
    const intervalId = setInterval(() => {
      let newX = x.get() - speed;
      if (newX < -totalItemsCount * itemWidth / 2) {
        newX = 0;  // reset to the beginning when reach the end
      }
      x.set(newX);
    }, 20);  // update every 20ms for smoothness
    return () => clearInterval(intervalId);
  }, [x]);

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    scrollYProgress.on('change', (e) => {
      if (scrollY.get() >= 100) {
        setNavbarTransparent(false)
      } else {
        setNavbarTransparent(true)
      }
    })
  }, [])

  return (
    <div className="bg-background-900 text-foreground-primary min-h-screen w-full font-roboto overflow-hidden text-xs sm:text-sm md:text-base" >
      <Head>
        <title>{t(`Transportation`)}</title>
        <meta name="description" content={t(`Improve traffic flow, detect incidents instantly, and enhance road safety with real-time AI insights.`)} />
      </Head>
      <Navbar transparent={navbarTransparent} language='en' />
      <div className="bg-gradient-to-b from-transparent to-container-background/90 w-full h-screen flex items-center justify-center">
        <main className="w-full flex justify-center -mt-12" >
          <div className="relative px-6 lg:px-8 max-w-7xl ">
            <div className="mx-auto pt-10 pb-14 sm:pt-20 sm:pb-12 ">

              <div className="text-center p-4" >
                <h1 className="text-2xl  sm:text-3xl  md:text-4xl lg:text-5xl font-bold tracking-tight ">
                  <Balancer>
                    {t("Optimizing Retail Operations with")}
                    <span
                      className=" bg-gradient-to-r from-[#F7A285] via-[#D4610A] to-[#F7A285] text-transparent bg-clip-text bg-300% animate-text-slow-gradient duration-700"
                    >
                      {" "}{t(`AI-Powered Computer Vision`)}{" "}
                    </span>
                  </Balancer>
                </h1>
                <p className="mt-8 text-lg sm:text-xl leading-8 text-foreground-secondary">
                  {t("Enhance store security, analyze customer behavior, and improve inventory management with real-time AI-driven insights.")}
                </p>
                <div className="w-full flex mt-8 items-center justify-center" >
                  <Cta >{t("Book a demo")}</Cta>
                </div>

              </div>

              {/* <div className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <svg
                  className="relative left-[calc(50%+3rem)] h-[21.1875rem] max-w-none -translate-x-1/2 sm:left-[calc(50%+36rem)] sm:h-[42.375rem]"
                  viewBox="0 0 1155 678"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="url(#ecb5b0c9-546c-4772-8c71-4d3f06d544bc)"
                    fillOpacity=".3"
                    d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
                  />
                  <defs>
                    <linearGradient
                      id="ecb5b0c9-546c-4772-8c71-4d3f06d544bc"
                      x1="1155.49"
                      x2="-78.208"
                      y1=".177"
                      y2="474.645"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#3849ab" />
                      <stop offset={1} stopColor="#42a5f5" />
                    </linearGradient>
                  </defs>
                </svg>
              </div> */}



            </div>
          </div>


        </main>
        <div className=" absolute bottom-[20px] md:px-20 w-full flex items-center justify-between dark:opacity-60" >
          <div className="carousel-container flex overflow-hidden mt-16 mx-auto ">
            <motion.div className="items flex" ref={carouselRef} style={{ x }}>
              {allPartners.map((item, index) => (
                <div key={index} className="item rounded-lg shadow m-2 flex items-center justify-center md:min-w-[140px] min-w-[120px] ">
                  <Image height={64} width={140} className="invert grayscale md:h-16 h-12 w-auto object-contain" src={item} alt="" />
                </div>
              ))}
            </motion.div>
          </div>

        </div>
      </div>

      <section className="py-10 sm:py-16 lg:py-24">
        <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="mt-10 text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">{t("Why AI Matters Here")}</h2>
          </div>

          <div
            className="grid items-center grid-cols-1 lg:grid-cols-2 gap-y-8 gap-x-12 xl:gap-x-20 my-12 lg:my-20 text-lg"
          >
            <div>
              <p className="mt-4  text-foreground-secondary">
                {t("AI-powered computer vision is transforming retail by enhancing security, optimizing store layouts, and improving inventory accuracy.")}
              </p>
              <p className="mt-4  text-foreground-secondary">
                {t("By leveraging real-time video analytics, retailers can detect shoplifting, monitor customer engagement, and streamline operations for a seamless shopping experience.")}
              </p>
            </div>

            <div className="relative">
              <div className="aspect-w-4 aspect-h-3">
                <img
                  className="object-cover w-full h-full"
                  src={retailImage}
                  alt={t("PPE")}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center mt-8 space-y-4 md:space-y-0 md:space-x-4 md:flex-row lg:mt-12">

            <Cta >{t("Book a demo")}</Cta>
          </div>

        </div>
      </section>

      <section className="py-10 bg-gradient-to-b from-container-background/30 to-container-background/70  text-foreground-primary sm:py-16 lg:py-24 ">
        <div className="max-w-3xl mx-auto text-center  mb-20 lg:mb-28">
          <h2 className="text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">{t("Real-World Applications of AI-Powered Vision")}</h2>
          {/* <p className="max-w-xl mx-auto mt-4 text-base leading-relaxed text-foreground-tertiary">AI transforms transportation into a smarter, safer, and more efficient ecosystem.</p> */}
        </div>
        <div className="max-w-7xl px-4 mx-auto sm:px-6 lg:px-8">
          {industry.examples.map((useCase, index) => (
            <>
              <div
                key={index}
                className="grid  grid-cols-1 lg:grid-cols-2 gap-y-8 gap-x-12 xl:gap-x-20 mb-12 lg:mb-20"
              >
                <div className={index % 2 !== 0 ? "md:order-last" : "md:order-first"}>
                  <h3 className="font-semibold text-xl">{t(useCase.name)}</h3>
                  {/* <p className="text-foreground-secondary mt-2">
                  {t(useCase.description)}
                </p> */}
                  {/* <h4 className="font-semibold text-lg mt-4">Key benefits:</h4> */}
                  <ul className="list-disc  text-foreground-secondary mt-6 lg:mt-12">
                    {useCase.benefits.map((benefit, _index) => (
                      <li key={_index} >
                        <strong className="text-foreground-primary" >{t(benefit.title)}</strong>: {t(benefit.description)}.
                      </li>
                    ))}
                  </ul>
                  <Button className="mt-6 lg:mt-12" >{t("See more examples")}</Button>
                </div>

                {/* <div className="relative">
                  <div className="aspect-w-4 aspect-h-3">
                    {useCase.video ? (
                      <>
                      <video 
                      muted
                      autoPlay
                      loop
                      src={useCase.video}></video>
                      </>
                    ) : (
                      <img
                        className="object-cover w-full h-full"
                        src={useCase.images[0]}
                        alt={t(useCase.name)}
                      />
                    )}

                  </div>
                </div> */}

                <ImageCarousel
                  images={useCase.video ? [useCase.video] : useCase.images}
                  alt={t(useCase.name)}
                  isVideo={useCase.video ? true : false}
                  interval={4000}
                />
              </div>

              {index < industry.examples.length - 1 && (
                <div className=" w-full h-[1px] bg-foreground-primary/10 mb-12 lg:mb-20" >

                </div>
              )}
            </>
          ))}
        </div>


      </section>

      <section className="py-10 sm:py-16 lg:py-24">
        <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="mt-10 text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">{t("How DeepNeuronic Transforms Retail")}</h2>
            <p className="max-w-xl mx-auto mt-4 text-base leading-relaxed text-foreground-tertiary">{t("AI-driven computer vision is revolutionizing retail by enhancing security, optimizing store operations, and providing real-time customer insights.")}</p>
          </div>

          <div id="cards" className="lg:mt-12 content-center  grid grid-cols-1 gap-x-6 gap-y-6 md:grid-cols-2 lg:grid-cols-3 sm:gap-y-8 lg:gap-x-8 items-center justify-center relative z-10">
            {CARDS.map((i) => (
              <GridCard fixedWidth={false} key={i.title} onSelect={() => console.log(i.title)}>
                <div className=" w-full  overflow-hidden flex justify-center" >
                  <Image width={36} height={36} className=" duration-200" src={i.icon} alt={i.title} />
                </div>
                <div className="h-[1px] my-4 w-full bg-gradient-to-r from-transparent via-card-divider to-transparent opacity-50" />
                <div className="w-full text-left" >
                  <p className="text-lg w-full text-center" >
                    {t(`${i.title}`)}
                  </p>
                  <p className="mt-2 text-foreground-tertiary " >
                    {t(`${i.description}`)}
                  </p>
                </div>
              </GridCard>
            ))}
          </div>

          <div className="flex flex-col items-center justify-center mt-8 space-y-4 md:space-y-0 md:space-x-4 md:flex-row lg:mt-12">

            <Cta >{t("Book a demo")}</Cta>
          </div>

        </div>
      </section>
      <IndustryGrid industry={industry} />
      <ContactUsSection />
      <Footer />
      <LanguageToggle />
    </div>
  );
}